<template>
  <div :class="iconClass" :style="{ width: size + 'px', height: size + 'px', marginRight: '0.3rem' }">
    <slot>
      <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M9.95804 12.1191C12.8172 12.1191 15.2585 12.572 15.2588 14.3857C15.2588 16.199 12.833 16.6689 9.95804 16.6689C7.09878 16.6689 4.65726 16.2155 4.65726 14.4023C4.65747 12.5886 7.08324 12.1192 9.95804 12.1191ZM5.47171 11.0273C5.48809 11.0296 5.49656 11.0411 5.49808 11.0479C5.50032 11.0591 5.49553 11.0759 5.47464 11.0879C4.96828 11.3396 3.01631 12.4332 3.26175 14.7383C3.27212 14.8388 3.19298 14.9244 3.09378 14.9102C2.61319 14.8411 1.37671 14.5735 0.993196 13.7412C0.780684 13.3007 0.780587 12.7901 0.993196 12.3496C1.24399 11.8131 1.84871 11.4443 2.76859 11.2627C3.20358 11.1569 4.37789 11.0071 5.47171 11.0273ZM14.5303 11.0264C15.6234 11.0061 16.7992 11.1561 17.2334 11.2627C18.1532 11.4436 18.7581 11.8131 19.0088 12.3496C19.2207 12.7902 19.2207 13.3014 19.0088 13.7412C18.6252 14.5734 17.3887 14.8401 16.9082 14.9092C16.8091 14.9241 16.7298 14.8381 16.7403 14.7383C16.9856 12.4321 15.0325 11.3383 14.5274 11.0869C14.5059 11.0757 14.5017 11.0583 14.5039 11.0479C14.5057 11.0403 14.5142 11.0286 14.5303 11.0264ZM9.95804 3.33594C11.9048 3.33594 13.4659 4.90446 13.4659 6.86328C13.4658 8.82129 11.9048 10.3916 9.95804 10.3916C8.01145 10.3915 6.4503 8.8212 6.45023 6.86328C6.45023 4.90455 8.0114 3.33607 9.95804 3.33594ZM5.28031 3.92383C5.48463 3.92383 5.68022 3.9454 5.87113 3.98438C5.89648 3.99038 5.92553 4.0029 5.94046 4.02539C5.95761 4.05389 5.94468 4.09242 5.92679 4.11719C5.36194 4.91347 5.03617 5.88506 5.03617 6.92676C5.03625 7.92462 5.33439 8.85411 5.85648 9.62695C5.9102 9.70651 5.86237 9.81454 5.76761 9.83105C5.63648 9.85427 5.50235 9.86635 5.36527 9.87012C3.99616 9.90614 2.76641 9.01977 2.42679 7.68555C1.92315 5.70354 3.40007 3.92398 5.28031 3.92383ZM14.7198 3.92383C16.6001 3.92383 18.0772 5.70347 17.5743 7.68555C17.2348 9.0199 16.0059 9.90608 14.6368 9.87012C14.4995 9.86636 14.364 9.85357 14.2334 9.83105C14.1389 9.81439 14.0911 9.70739 14.1446 9.62793C14.6669 8.85491 14.9649 7.92493 14.9649 6.92676C14.9649 5.88508 14.6401 4.91346 14.0752 4.11719C14.0574 4.09244 14.0437 4.05484 14.0616 4.02637C14.0765 4.0031 14.1038 3.99038 14.1299 3.98438C14.32 3.94538 14.5155 3.92386 14.7198 3.92383Z"
          fill="currentColor"
        />
      </svg>
    </slot>
  </div>
</template>

<script>
  export default {
    name: 'IconLead',
    props: {
      iconClass: {
        type: String,
        default: '',
      },

      size: {
        type: [Number, String],
        default: '',
      },
    },
  };
</script>

<style scoped>
  /* You can add any additional styles here */
</style>
